import { QA_SUCCESS } from "../constants/ActionTypes";

const initialState = {
  tests: [],
};

export default function modal(state = initialState, action) {
  switch (action.type) {
    case QA_SUCCESS:
      return Object.assign({}, state, {
        tests: action.data,
      });
    default:
      return state;
  }
}
